<a 
  [routerLink]="['/catalog/product', product.id, modifyProductName(product.name)]"
  [attr.target]="'_blank'"
  (click)="sendProduct()"
>
<mat-card  class="product-card" [ngClass]="{ 'list-card': cardType === 'list' }">
  <mat-card-content style="cursor: pointer;">
    <div class="product-image" [ngClass]="{disconnected: isConnected === false}">
      <a >
        <img
          [src]="image ? image : logoUrl"
          alt="{{ product.name }}"
          (error)="image = null"
        />
      </a>
    </div>

    <div class="product-title">
      <a>
        <h2 title="{{ product.name }}">
          {{ product.name }}
        </h2>
      </a>
    </div>
    <div class="product-description">
          <pre  class="plainDescription" [innerHTML]="plainDescription"></pre >

      <div
        class="product-description-ref"
        fxLayout="row nowrap"
        fxLayoutGap="8px"
      >

        <span
          [ngClass]="{
            'in-stock__status': product?.productStatus === 'IN_STOCK',
            'on-command__status': product?.productStatus === 'ON_COMMAND',
            'obsolete__status': product?.productStatus === 'OBSOLETE',
            'out-of-stock__status': product?.productStatus === 'OUT_OF_STOCK'
          }"
        >
          {{ product?.productStatus === "IN_STOCK" ? "En stock" : "" }}
          {{ product?.productStatus === "OBSOLETE" ? "Produit obsolète" : "" }}
          {{ product?.productStatus === "OUT_OF_STOCK" ? "Rupture de stock" : "" }}
          {{ product?.productStatus === "ON_COMMAND" ? "Sur commande" : "" }}
        </span>
      </div>
    </div>
    <div *ngIf="isConnected===true" class="product-price">
      <span class="price">{{ calculatePrice() +  (displayDeee ?product.priceDeee:0) | currency: "EUR":'symbol' }}</span>
      <span class="old-price" *ngIf="discountDaysLeft > 0">
        {{ product.price + (displayDeee ?product.priceDeee:0) | currency: "EUR":'symbol' }}
      </span>
    </div>

    <div *ngIf="isConnected===true" class="card-add-btn" (click)="$event.stopPropagation()">
      <button
        *ngIf="(product?.productStatus === 'IN_STOCK' || product?.productStatus === 'ON_COMMAND') "
        (click)="$event.stopPropagation();$event.preventDefault();addToCart()"
        mat-button
        title="{{hasSufficientStock() ? 'Ajouter au panier' : 'Stock insuffisant'}}"
        [ngClass]="{'disabled': !hasSufficientStock() || (addToCartLoading | async)}"
        [disabled]=" (addToCartLoading | async)"
        class="app-raised-button add-cart-btn"
      >
        <mat-spinner *ngIf="(addToCartLoading | async); else addToCartBtn" [diameter]="25"></mat-spinner>

        <ng-template #addToCartBtn>
          <div style="display: flex">
            <img
              style="width: 1.5em; display: inline;"
              src="assets/icons/shopping_cart-white.svg"
              alt="shopping cart"
            />
            <span style="color: white">&nbsp;AJOUTER AU PANIER</span>
          </div>
        </ng-template>
      </button>
    </div>
    <div *ngIf="isConnected===true" class="card-add-btn" (click)="$event.stopPropagation()">
      <button
        *ngIf="product?.productStatus === 'OBSOLETE' || ( product?.productStatus === 'OUT_OF_STOCK')"
        (click)="addQuote()"
        mat-button
        class="app-raised-button add-cart-btn"
      >
        <div style="display: flex; align-items: center;">
          <img style="width: 1.5em;  display: inline;"  src="assets/icons/shopping_cart-white.svg" alt="shopping cart"/>
          <span style="color: white">          &nbsp;AJOUTER AU DEVIS
            </span>
        </div>
      </button>
    </div>
  </mat-card-content>

  <!--  Promo Labels  -->
  <ng-container *ngIf="discountDaysLeft > 0">
    <div class="promo-label">
      <span
      >PROMO {{displayDiscount()}}</span
      >
    </div>
    <div class="end-promo-label">
      <span>Expire dans {{ discountDaysLeft }} jrs</span>
    </div>
  </ng-container>
</mat-card>
</a>